export function isNumeric(value: unknown): boolean {
  if (typeof value === 'number') {
    return isFinite(value)
  }
  if (typeof value === 'string') {
    const trimmed = value.trim()
    return trimmed !== '' && !isNaN(Number(trimmed))
  }
  return false
}

export default isNumeric
